import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {UserDepartmentInterface} from "../../services/interface/UserDepartmentInterface";
import CustomTable, {TypeItemTable} from "../../components/general/CustomTable";
import {UserInterface} from "../../services/interface/UserInterface";
import {useFindPermissionsDepartment} from "../../services/admin-user/apiPermission";
import CustomIcon from "../../components/general/CustomIcon";
import SelectPermission from "./SelectPermission";

interface Props {
    user?: UserInterface;
}
export default function ProcessAccess({user}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string }

    const {
        mutate: findPermissionsDepartment,
        isPending: isLoadingFind,
        data: successFindPermissions
    } = useFindPermissionsDepartment();

    const [list, setList] = React.useState<UserDepartmentInterface[] | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()

    useEffect(() => {
        if (user && user.username) {
            findPermissionsDepartment({idUser: user.username})
        }
    }, [user]);

    useEffect(() => {
        if (successFindPermissions) {
            setList(successFindPermissions)
        }
    }, [successFindPermissions]);

    useEffect(() => {
        if (list) {
            setListElement(list.map((item) => ({
                row: [
                    item.department,
                    item.departmentDescription ? item.departmentDescription : '-',
                    <div className={'flex items-center justify-center'}>
                        {item.departmentIcon ? <CustomIcon iconName={item.departmentIcon}/> : <>-</>}
                    </div>,
                    <div className={'min-w-[180px] p-2'}>
                        <SelectPermission {...{item}}/>
                    </div>
                ]
            })))
        }
    }, [list]);

    return (
        <>
            <CustomTable
                highTable={'400px'}
                header={[
                    t('department'),
                    t('description'),
                    t('icon'),
                    t('rol'),
                ]}
                loading={isLoadingFind}
                {...{listElement}}
            />
        </>
    )
}
